// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__r6UWe","delete":"styles_delete__2R9ju","update":"styles_update__LGUVR","add":"styles_add__3NEqG"};